export type ValidationMessage = {
  field: string;
  message: string;
};

export type ApiErrorType = {
  errorMessage: string;
  errorCode?: string;
  moreInfo?: string;
  redirectUrl?: string;
  validationMessages?: ValidationMessage[];
};

export class ApiError extends Error {
  errorCode: string | undefined;
  moreInfo: string | undefined;
  redirectUrl: string | undefined;
  validationMessages: ValidationMessage[] | undefined;

  constructor({
    errorMessage,
    errorCode,
    moreInfo,
    redirectUrl,
    validationMessages,
  }: ApiErrorType) {
    super(errorMessage);
    this.name = 'ApiError';
    this.errorCode = errorCode;
    this.moreInfo = moreInfo;
    this.redirectUrl = redirectUrl;
    this.validationMessages = validationMessages;
  }
}
